enum LogTypes {
  NONE = "None",
  OPENED = "Opened",
  CURRENT_PRICE = "Current price",
  HIGHEST_BIDDER = "Highest bidder",
  NEW_BID = "New bid",
  AUTO_BID = "Auto bid",
  RETRACTED_BID = "Retracted bid",
  SOLD = "Sold",
  UNSOLD = "Unsold"
}

export default LogTypes;
